import {GameInfo} from "../../games/game-info";

export enum ApplyGameFilterResult {
    IncludeGame,
    ExcludeGame,
    NotApplicable
}

export interface IGameFilterEvaluator {
    applyFilter(gameInfo: GameInfo, selectedFiltersIDs?: string[]): ApplyGameFilterResult;
}